// extracted by mini-css-extract-plugin
module.exports = {"container":"Features-module--container--3JO7d"};